import { Injectable } from "@angular/core";
import { NgbDatepickerI18nDefault } from "@ng-bootstrap/ng-bootstrap";

/**
 * Hides the year from the date picker
 */
@Injectable()
export class CustomDateI18n extends NgbDatepickerI18nDefault {
  getYearNumerals(year: number): string {
    return '';
  }
}